var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.04094L9.295 3.33594L6.5 6.13094L3.705 3.33594L3 4.04094L5.795 6.83594L3 9.63094L3.705 10.3359L6.5 7.54094L9.295 10.3359L10 9.63094L7.205 6.83594L10 4.04094Z",
    fill: "#445386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconSmall);
export default __webpack_public_path__ + "static/media/crossIconSmall.44f349db47fd118331efb9ab81550865.svg";
export { ForwardRef as ReactComponent };